(function() {
  'use strict';

  function UserBasicController($q, $rootScope, $scope, $translate, Form, Notify, User, Utils) {
    var ctrl = this;

    ctrl.action = $scope.action;
    if (ctrl.action === 'edit') {
      $scope.$watch('ctrl.userBasicForm', function(val) {
        $scope.$emit('KZUserFormChanged', { form: val });
      });
      ctrl.profile = angular.copy($scope.profile);
    } else {
      ctrl.profile = $scope.profile;
    }

    ctrl.basicForm = new Form([
      { id: 'firstName', label: $translate.instant('First Name'), type: 'string', required: true },
      { id: 'lastName', label: $translate.instant('Last Name'), type: 'string', required: true }
    ]);

    const fileOptions = {
      accept: ['images'],
      sizeLimit: 2,
      multiple: false,
      storeSingle: true,
      fileLimit: 0
    };

    ctrl.profilePhotoForm = new Form([
      {
        id: 'profilePicture',
        label: $translate.instant('Profile picture'),
        type: 'file',
        docId: ctrl.profile._id,
        fileOptions: fileOptions,
        hideList: true,
        required: false,
        // eslint-disable-next-line max-len
        helpText: $translate.instant('Please make sure the photo is square and at least 100 x 100px. Maximum file size is 2MB.'),
        onModelUpdated: function(files) {
          if (_.isEmpty(files)) {
            if (ctrl.profilePictureSource) {
              ctrl.profilePictureSource = null;
            }
            return;
          }

          let fileModel = files[0];
          if (fileModel.file === undefined) {
            return;
          }

          ctrl.parseImage(fileModel.file)
            .then(function(uploadedImage) {
              ctrl.profilePictureSource = uploadedImage;
            });
        }
      }
    ]);

    ctrl.parseImage = function(file) {
      var q = $q.defer();
      var reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = function() {
        q.resolve(reader.result);
      };
      reader.onerror = function() {
        console.log(reader.error);
        q.reject(reader.error);
      };
      return q.promise;
    };

    ctrl.saveProfile = function(isValid) {
      if (!isValid) {
        Utils.showError({ message: 'Form is not valid' });
        return;
      }

      var formFields = _.union(ctrl.basicForm.fields, ctrl.profilePhotoForm.fields);

      return User.partiallySaveProfile('basic', formFields, ctrl.profile)
        .then(function(newProfile) {
          _.assignIn($scope.profile, newProfile);
          ctrl.profile = newProfile;
          Notify.success('The basic information has been saved!');
          $rootScope.$broadcast('KZProfileUpdated', { profile: ctrl.profile });
          ctrl.userBasicForm.$setPristine();
        })
        .catch(function(e) {
          Notify.error(e.message, 'An error occured while saving');
        });
    };
  }

  UserBasicController.$inject = [
    '$q',
    '$rootScope',
    '$scope',
    '$translate',
    'FormsService',
    'NotifyService',
    'UserFactory',
    'UtilsService'


  ];

  function UserBasicDirective() {
    return {
      scope: {
        action: '@',
        profile: '='
      },
      restrict: 'AE',
      templateUrl: 'app/components/users/directives/userBasic.html',
      replace: true,
      controller: UserBasicController,
      controllerAs: 'ctrl'
    };
  }

  angular.module('component.users')
    .directive('userBasic', UserBasicDirective)
    .controller('UserBasicController', UserBasicController);
})();
